import { BlogArticleSort } from './client';

export const STRAPI_FEATURE_FLAGS = {
    ENABLE_AUTHOR: false,

    ENABLE_CATEGORY: false,

    ENABLE_TAGS: false,
} as const;

export function getArticlePopulateFields(includeBlocks = false): string[] {
    const fields: string[] = ['cover'];

    if (STRAPI_FEATURE_FLAGS.ENABLE_AUTHOR) {
        fields.push('author', 'author.avatar');
    }

    if (STRAPI_FEATURE_FLAGS.ENABLE_CATEGORY) {
        fields.push('category');
    }

    if (STRAPI_FEATURE_FLAGS.ENABLE_TAGS) {
        fields.push('tags');
    }

    if (includeBlocks) {
        fields.push('blocks', 'blocks.file', 'blocks.files');
    }

    return fields;
}

export function getArticleSortOrder(): BlogArticleSort {
    return 'publishedAt:desc';
}

export function getArticlePagination(pageSize = 100) {
    return {
        page: 1,
        pageSize,
    };
}
